<template>
  <div>
    <b-modal id="filter" no-close-on-backdrop hide-footer title="FILTRAR">
      <div class="row">
        <div class="col-md-6">
          <label>DATA INICIAL</label>
          <input type="date" v-model="start" class="form-control" />
        </div>
        <div class="col-md-6">
          <label>DATA FINAL</label>
          <input type="date" v-model="end" class="form-control" />
        </div>
        <div class="col-md-12 pt-0 pb-0">
          <ErrorsMessages :errors="errors" />
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right">
          <v-btn @click="handleFilter" class="btn-filter" type="relief">
            <i class="fas fa-filter mr-2 text-twenty"></i>
            FILTRAR
          </v-btn>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="execute"
      no-close-on-backdrop
      hide-footer
      title="RECEBER"
      size="sm"
    >
      <execute
        :service_ids="service_ids"
        :stock_sale_ids="stock_sale_ids"
        @success="handleSuccessExecute"
      />
    </b-modal>
    <div class="text-right mb-3">
      <v-btn @click="$bvModal.show('filter')" class="btn-filter" type="relief">
        <i class="fas fa-filter mr-2 text-twenty"></i> FILTRAR
      </v-btn>
    </div>
    <div class="v-clean p-2">
      <hosting
        :loading="loading"
        :resident_id="resident_id"
        :data="data.hosting.data"
        :total_value="data.hosting.total_value"
        :start="start"
        :end="end"
        @selected="handleSelected"
        v-if="permission('read', 'resident_hosting')"
      />
    </div>
    <div class="v-clean mt-2 p-2">
      <service
        :loading="loading"
        :resident_id="resident_id"
        :data="data.service.data"
        :total_value="data.service.total_value"
        :start="start"
        :end="end"
        @selected="handleSelected"
        v-if="permission('read', 'resident_service')"
      />
    </div>
    <div class="v-clean mt-2 p-2">
      <stock-sale
        :loading="loading"
        :resident_id="resident_id"
        :data="data.stock_sale.data"
        :total_value="data.stock_sale.total_value"
        :start="start"
        :end="end"
        @selected="handleSelected"
        v-if="permission('read', 'resident_rest_home_sale_resident')"
      />
    </div>
    <div class="v-clean mt-2 p-2 pt-5 pb-5 text-right">
      <h1 class="title-pages">
        TOTAL FINAL: R$
        {{
          data.service.total_value || data.stock_sale.total_value
            ? formatPrice(
                parseFloat(data.service.total_value) +
                  parseFloat(data.stock_sale.total_value)
              )
            : "0,00"
        }}
      </h1>
      <hr />
      <v-btn
        class="btn-save"
        :disabled="btnExecute"
        @click="$bvModal.show('execute')"
      >
        <i class="fas fa-check mr-2"></i>
        RECEBER
      </v-btn>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages.vue";

import Hosting from "./releases/hosting.vue";
import Service from "./releases/service.vue";
import StockSale from "./releases/stock-sale.vue";

import Execute from "./releases/execute.vue";

import api from "../../../../services/api";

import routes from "../../../../routes";

import { formatPrice } from "../../../../lib/format";

import moment from "moment";

import permission from "../../../../lib/permission";

export default {
  name: "ReleasePending",

  components: {
    ErrorsMessages,
    Hosting,
    Service,
    StockSale,
    Execute,
  },

  props: {
    resident: Object,
  },

  data() {
    return {
      resident_id: "",
      start: moment().subtract(30, "days").format("YYYY-MM-DD"),
      end: moment().format("YYYY-MM-DD"),

      expanded: [],

      data: {
        hosting: {
          data: [],
          total_value: 0,
        },
        service: {
          data: [],
          total_value: 0,
        },
        stock_sale: {
          data: [],
          total_value: 0,
        },
      },

      loading: false,

      service_ids: [],
      stock_sale_ids: [],

      errors: [],
    };
  },

  computed: {
    btnExecute() {
      if (this.service_ids.length == 0 && this.stock_sale_ids.length == 0) {
        return true;
      }

      return false;
    },
  },

  created() {
    this.retrieve();
  },

  methods: {
    moment,
    formatPrice,
    permission,

    handleSuccessExecute() {
      this.service_ids = [];
      this.stock_sale_ids = [];
      this.paginate();
    },

    handleSelected({ type, ids }) {
      if (type == "service") {
        this.service_ids = ids;
      }
      if (type == "stock-sale") {
        this.stock_sale_ids = ids;
      }
    },

    retrieve() {
      const { id } = routes.history.current.params;

      this.resident_id = id;

      this.paginate();
    },

    handleFilter() {
      this.paginate();
    },

    async paginate() {
      try {
        this.loading = true;

        let { resident_id, start, end } = this;

        let params = {
          resident_id,
          start,
          end,
          status: 1,
        };

        const response = await api.get("/rest-home/family/releases", {
          params,
        });

        const { error, errors, data } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          let hosting = { data: [], total_value: 0 };
          let service = { data: [], total_value: 0 };
          let stock_sale = { data: [], total_value: 0 };

          if (permission("read", "resident_hosting")) {
            hosting = data.hosting;
          }

          if (permission("read", "resident_service")) {
            service = data.service;
          }

          if (permission("read", "resident_rest_home_sale_resident")) {
            stock_sale = data.stock_sale;
          }

          this.data = { hosting, service, stock_sale };
          this.$bvModal.hide("filter");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
.v-data-footer {
  background-color: #fff !important;
}
</style>